import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { Step, StepAction } from '../../types/Step';
import { UserSettingsCollapseKeys } from '../../types/User';
import AccordionSection from '../AccordionSection';
import { StepItem } from './StepItem';
import { columns } from './StepItemStyles';

interface StepsTableProps {
  steps: Step[];
  handleStepToggle: (step: Step, action: StepAction) => void;
  editPermitted: boolean;
  taskUuid: string;
  loadingStep: { uuid: string; action: StepAction } | null;
}

const StepTable = ({ steps, handleStepToggle, editPermitted, taskUuid, loadingStep }: StepsTableProps) => {
  const sortedSteps = _.sortBy(steps, 'order');

  return (
    <AccordionSection title="Steps" collapseId={UserSettingsCollapseKeys.TASK_ITEM_STEPS} hasData={steps.length > 0} scrollable>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Step Name</TableCell>
              <TableCell sx={columns}>Start</TableCell>
              <TableCell sx={columns} width={'100%'}>
                Complete
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedSteps.map((step) => (
              <TableRow key={step.uuid}>
                <StepItem step={step} handleStepToggle={handleStepToggle} editPermitted={editPermitted} taskUuid={taskUuid} loadingStep={loadingStep} />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </AccordionSection>
  );
};
export default StepTable;
